<template>
  <section class="exhibition">
    <div class="section">
      <div class="container">
        <div class="item">
          <div class="service-show-image">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide class="test">
                <img class="img" src="@/assets/img/show_pic7.png" />
              </swiper-slide>
              <swiper-slide class="test">
                <img class="img" src="@/assets/img/show_pic8.png" />
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
          <div class="service-details">
            <h3 class="item-title">能源物联网集控平台 </h3>
            <p class="text">
              能源物联网集控平台是集电力设备管理、数据采集、远程控制、资产管理、运维管理、视频管理、事件报警、
              能源分析等功能于一体的综合业务平台。提供PC WEB端和 APP端，方便用户随时访问。
            </p>    
          </div>
        </div>
      </div>
    </div>  
  </section>
</template>

<script>
import "swiper/dist/css/swiper.css";
export default {
  name: 'ServiceDetails',
  data() {
    return {
      swiperOption: {
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
          dynamicBullets: false
        },
        // speed: 1000,
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // },
        effect: "slide",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.swiper.slideTo(3, 1000, false);
  }
}

</script>

<style lang="scss" scoped>
p {
  margin-top: 0;
  margin-bottom: 1rem;
}
.exhibition {
  margin: 0 auto;
}

.title {
  width: 100%;
  padding: 140px 0 130px;
  margin-top: 65px;
  background: url('../../assets/img/banner-bg1.jpg') center no-repeat;

  .content {
    font-size: 24px;
    font-weight: 700;
    color: #0e314c;
  }
}

.section {
  padding: 80px 0;

  @media (max-width: 745px) {
    padding: 50px 0;
  }
}

.container {
  @media (max-width: 575px) {
    .item{
      flex-flow: column-reverse;

      .service-details{
        .item-title{
          text-align: center;
        }
        .text{
          text-indent: 25px;
        }
      }

      .service-show-image{
        width: auto!important;
      }
    }
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1040px;
  }

  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
  box-sizing: border-box;

  .item {
    display: flex;
    box-sizing: border-box;
    justify-content: center;

    .service-details {
      display: flex;
      flex: 1;
      flex-flow: column wrap;
      justify-content: center;
      text-align: left;
      padding: 0 15px;

      .item-title {
        color: #0e314c;
        font-size: 18px;
        margin: 0 0 15px;
      }

      .text {
        font-size: 14px;
        color: #6084a4;
        line-height: 1.9;
      }
    }

    .service-show-image{
      display: flex;
      flex: 1;
      width: 50%;
      padding: 0 15px;

      .test{
        width: 100% !important;

        .img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      
    }
  }
}
</style>